import { tw } from '@/utils/tw';

const Heading = tw.theme({});

export default Heading;
